export enum SegmentEntityType {
    USER = 'user',
    METRIC = 'metric',
    BEHAVIOUR = 'behaviour',
    SUB_BEHAVIOUR = 'subBehaviour',
}
